import repository from "../Repository";

export default {
  async list(screenId) {
    return repository.post(
      "disaster_staff_mst_info",
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async ownList(screenId) {
    return repository.post(
      "disaster_staff_mst_info",
      { own: true },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async create(screenId, payload) {
    return await repository.post("disaster_staff_mst_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch("disaster_staff_mst_ope", payload, {
      headers: {
        s: screenId
      }
    });
  }
};
